module.exports = __webpack_public_path__ + "static/img/logo-zy.01c36712.png";